
import { Box, Stack } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useTranslate } from "src/locales";
import ByzMuiButton from "src/components/core-components/mui/buttons/ByzMuiButton";

export const HistoryButtonsSection = () => {
  const { t } = useTranslate();

  const buttonGroups = [
    [
      { label: "adult-patient-assessment.allergies", log: "Alerjiler" },
      { label: "adult-patient-assessment.habits", log: "Alışkanlıklar" },
      { label: "adult-patient-assessment.family-history", log: "Soy Geçmiş" },
      { label: "adult-patient-assessment.past-illnesses", log: "Geçirilmiş Hastalıklar" },
      { label: "adult-patient-assessment.diseases", log: "Hastalıklar" },
      { label: "adult-patient-assessment.past-surgeries", log: "Geçirilmiş Ameliyatlar" },
    ],
    [
      { label: "adult-patient-assessment.special-notes", log: "Özel Notlar" },
      { label: "adult-patient-assessment.rare-diseases", log: "Nadir Hastalıklar" },
      { label: "adult-patient-assessment.blood-pressure-monitoring", log: "Tansiyon Takibi" },
      { label: "adult-patient-assessment.exposures", log: "Maruziyetler" },
      { label: "adult-patient-assessment.current-medications", log: "Kullandığı İlaçlar" },
    ]
  ];

  const buttonSx = {
    backgroundColor: "#63B4FF33",
    color: "#2979C3",
    border: "1px solid #2979C3",
    width: "100%",
    height: "30px",
    borderRadius: "20px",
    whiteSpace: "nowrap",
  };

  return (
    <Box
      sx={{
        border: "1px solid #DBDBDB",
        borderRadius: "4px",
        padding: "20px",
        width: "100%",
        marginTop: "20px",
      }}
    >
      <Stack spacing={2}>
        {buttonGroups.map((group) => (
          <Grid key={group[0].label} container spacing={2}>
            {group.map((btn) => (
              <Grid key={btn.label} md={2} xs={4}>
                <ByzMuiButton
                  onClick={() => console.log(btn.log)}
                  marginLeft="0px"
                  sx={buttonSx}
                >
                  {t(btn.label)}
                </ByzMuiButton>
              </Grid>
            ))}
          </Grid>
        ))}
      </Stack>
    </Box>
  );
};
